module.exports = __webpack_public_path__ + "static/tcdd-case-study-3116dddb5b999c55e705019ec17f7583.webp";